import React, { useState , useEffect } from 'react';
import NumberFormat from 'react-number-format';

export default function Input(props) {
  const [ error , setError ] = useState(false);
  const [ value , setValue ] = useState(props.value || '');

  const formats = {
    'phone' : /^(\d{2}\s){4}\d{2}$/,
    'email': /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    'leclercEmail': /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i
  }

  useEffect(() => {
    if(props.format && (value || value === 0)){
      let regex = formats[props.format];
      if(!regex.test(value)){
        setError(true)
      } else{
        setError(false)
      }
    }
  },[value , formats , props.format ]);

  function handleChange(val) {
    let inputValue = val;
    if (props.type === "number" && val.includes(',')) {
      inputValue = val.replace(".",",");
    }
    props.onChange(inputValue);
    setValue(inputValue);
  }

  useEffect(() => {
    if (props.value || props.value === 0) {
      setValue(props.value);
    }
  },[props.value]);

  return (
    <div className={props.className}>
      <label className="bold">{props.label}</label>
        {props.maskNumber ?
          <NumberFormat
            className={error ? "error" : ""}
            value={value}
            type={props.format === "phone" ? "tel" : props?.type}
            format={props.maskNumber}
            onChange={(e) => handleChange(e.target.value)}
          />
          :
          <input
            className={error ? "error" : ""}
            type={props.type}
            step={props.step || null}
            style={props.style || {} }
            value={value}
            placeholder={props?.placeholder || null}
            disabled={props.disabled || false}
            onChange={(e) => handleChange(e.target.value)}/>
        }
        <span className="text-error">{props.error ? props.error : ""}</span>
    </div>
  )
}
